import { createActions } from 'redux-actions';

const actions = createActions({
  TASK: {
    SET_TASK_SUCCESS: (success) => ({ success }),
    API: {
      SET_TASK_SUCCESS: undefined
    }
  }
})

const configuration = {
  name: 'setTaskSuccess',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      setTaskSuccess: action.payload.success
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/setTaskSuccess.js